import React from "react";

export default function SettingHeader({ title }) {
    return (
        <div className="tw-w-full">
            <div className="tw-flex tw-w-full tw-flex-col tw-px-[20px]   tw-mt-[70px]">
                <div className="tw-flex tw-w-full tw-justify-between">
                    <h2 className="tw-text-[32px] tw-font-[600]">{title}</h2>
                </div>
                {title && (
                    <p className="tw-text-[14px] tw-font-normal tw-flex tw-gap-2">
                        <span className="tw-text-gray-500">{"Setting >  "}</span> {title}
                    </p>
                )}
            </div>
        </div>
    );
}
